import { GlobalInfoService } from './../core/utilities/global-info.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { Const } from '@app/shared';
import { environment } from '@env/environment';

@Component({
  selector: 'iw-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss'],
})
export class AdministrationComponent implements OnInit {
  // Activa el modulo de administracion de procesos
  activateAccessProcess = false;
  // Activa el modulo de administracion de tablas maestras
  activateAccessMasterTables = false;
  // Activa el modulo de administracion de utilitarios
  activateAccessUtilies = false;
  // Activa el modulo de administracion de publicaciones
  activateAccessPublications = false;
  // Activa el modulo de administracion de Iframes
  activateAccessIframes = false;
  // Activa el modulo de administracion de grupos y permisos
  activateAccessGroupsPermissions = false;
  // Activa el modulo de administracion de dias especiales
  activateAccessHoliDays = false;
  // Activa el modulo de administracion de formas dinamicas
  activateAccessForms = false;
  // Activa el modulo de administracion de reportes
  activateAccessReports = false;
  // Activa el modulo de administracion de documentos
  activateAccessDocuments = false;
  // Activa el modulo de administracion general del sistema
  activateAccessManagementSystem = false;
  // Activa el modulo de inactivación de usuarios
  activateAccessInactivateUsers = false;
  // Activa el modulo de administracion de Ayudas
  activateAccessHelps = false;
  // Activa el modulo de administracion de consecutivos de actas
  activateAccessManagementConsecutiveAct = false;
  // Activa el modulo de administracion de procesos basica
  activateAccessProcessBasic = false;

  constructor(
    private gis: GlobalInfoService,
    private as: AuthenticationService
  ) { }

  ngOnInit() {
    // se setea el titulo de la vista actual
    this.gis.set({ title: 'Administración' });
    // Se validan los permisos para mostrar las cards de los modulos de administracion
    this.activateAccessProcess = this.as.confirmPermission(Const.types_permissions.administrationProcess);
    this.activateAccessMasterTables = this.as.confirmPermission(Const.types_permissions.administrationMasterTables);
    this.activateAccessUtilies = this.as.confirmPermission(Const.types_permissions.administrationUtilities);
    this.activateAccessIframes = this.as.confirmPermission(Const.types_permissions.administrationIframes);
    this.activateAccessPublications = this.as.confirmPermission(Const.types_permissions.administrationPublications);
    this.activateAccessGroupsPermissions = this.as.confirmPermission(
      Const.types_permissions.administrationGroupsPermissions
    );
    this.activateAccessHoliDays = this.as.confirmPermission(Const.types_permissions.administrationHoliDays);
    this.activateAccessForms = this.as.confirmPermission(Const.types_permissions.administrationForms);
    this.activateAccessReports = this.as.confirmPermission(Const.types_permissions.administrationReports);
    this.activateAccessDocuments = this.as.confirmPermission(Const.types_permissions.administrationDocument);
    this.activateAccessManagementSystem = this.as.confirmPermission(Const.types_permissions.administrationSystem);
    this.activateAccessInactivateUsers = this.as.confirmPermission(Const.types_permissions.administracionInactivacionUsuarios);
    this.activateAccessManagementConsecutiveAct = this.as.confirmPermission(
      Const.types_permissions.adminConsecutiveAct
    );
    if (environment.Helps){
      this.activateAccessHelps = this.as.confirmPermission(Const.types_permissions.adminHelps);
    }
    this.activateAccessProcessBasic = this.as.confirmPermission(Const.types_permissions.administrationProcessBasic);
    if (this.activateAccessProcess) {
      this.activateAccessProcessBasic = true;
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/administration.component.ts